/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// libraries
import React, { useContext } from 'react';
import {
    shape, arrayOf, func, number, bool, object,
} from 'prop-types';
import Loadable from 'react-loadable';
import { CrossMerch } from '../../../CrossMerchContainer/CrossMerchContainer';

const PersonalizeYourGiftComponent = Loadable({
    loader: () => import(/* webpackChunkName: "PersonalizeYourGiftV1" */ './v1/PersonalizeYourGift'),
    loading: () => <div />,
});
const PersonalizeYourGiftComponentV2 = Loadable({
    loader: () => import(/* webpackChunkName: "PersonalizeYourGiftV2" */ './v2/PersonalizeYourGift'),
    loading: () => <div />,
});

const PersonalizeYourGift = ({
    handlePersonalizeInputChange, getUpdatedPersonalizedProdData, personalization, product,
}) => {
    const { featureFlags = {}, presentation_family: presentationFamily = '' } = useContext(CrossMerch);
    let response = null;
    if (featureFlags['is-personalization-pdp-enabled'] && product?.isPersonalizable && personalization?.lines?.length > 0) {
        response = featureFlags['is-pdp-v-2-enabled'] ? (
            <PersonalizeYourGiftComponentV2
                handlePersonalizeInputChange={handlePersonalizeInputChange}
                getUpdatedPersonalizedProdData={getUpdatedPersonalizedProdData}
                personalization={personalization}
                presentationFamily={presentationFamily}
                featureFlags={featureFlags}
            />
        ) : (
            <PersonalizeYourGiftComponent
                handlePersonalizeInputChange={handlePersonalizeInputChange}
                getUpdatedPersonalizedProdData={getUpdatedPersonalizedProdData}
                personalization={personalization}
                product={product}
                presentationFamily={presentationFamily}
                featureFlags={featureFlags}
            />
        );
    }
    return response;
};
PersonalizeYourGift.propTypes = {
    handlePersonalizeInputChange: func.isRequired,
    getUpdatedPersonalizedProdData: func.isRequired,
    product: object.isRequired,
    personalization: shape({
        lines: arrayOf(
            shape({
                lineNumber: number,
                maxChars: number,
            }),
        ),
    }).isRequired,
    featureFlags: bool.isRequired,
};

export default  PersonalizeYourGift;
